// Global Instructions Rule Applied!

export const SET_INVESTOR_STATEMENT_RUNS = 'investor_statement_runs/SET_INVESTOR_STATEMENT_RUNS' as const
export const APPEND_INVESTOR_STATEMENT_RUNS = 'investor_statement_runs/APPEND_INVESTOR_STATEMENT_RUNS' as const
export const SET_ACTIVE_FILTERS = 'investor_statement_runs/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'investor_statement_runs/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'investor_statement_runs/CLEAR_ACTIVE_FILTERS' as const
export const UPDATE_INVESTOR_STATEMENT_RUN_RECORD = 'investor_statement_runs/UPDATE_INVESTOR_STATEMENT_RUN_RECORD' as const
export const REMOVE_INVESTOR_STATEMENT_RUN = 'investor_statement_runs/REMOVE_INVESTOR_STATEMENT_RUN' as const
